/**
 * @description 安全 json 解析，报错时可返回默认值
 * @param data 解析数据
 * @param errorReturnValue 报错返回数据
 */
export function safeJsonParse<T = Record<string, any>>(data: string, errorReturnValue = {}) {
  try {
    return JSON.parse(data) as T;
  } catch (e) {
    console.error(e, 'JSON Parse Error');
    return errorReturnValue as T;
  }
}

/**
 * 随机唯一id
 * @returns string
 */
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 复制文本到剪贴板
 * @param {string} text 要复制的文本
 * @param {string | null} 复制成功时的提示文本
 */
export function copy(text: string, _prompt: string | null = '已成功复制到剪切板!') {
  if (navigator.clipboard) {
    return navigator.clipboard
      .writeText(text)
      .then(() => {
        // prompt && message.success(prompt);
      })
      .catch((error) => {
        // message.error('复制失败!' + error.message);
        return error;
      });
  }
  if (Reflect.has(document, 'execCommand')) {
    return new Promise<void>((resolve, reject) => {
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        // 在手机 Safari 浏览器中，点击复制按钮，整个页面会跳动一下
        textArea.style.width = '0';
        textArea.style.position = 'fixed';
        textArea.style.left = '-999px';
        textArea.style.top = '10px';
        textArea.setAttribute('readonly', 'readonly');
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        // prompt && message.success(prompt);
        resolve();
      } catch (error) {
        // message.error('复制失败!' + error.message);
        reject(error);
      }
    });
  }
  return Promise.reject(`"navigator.clipboard" 或 "document.execCommand" 中存在API错误, 拷贝失败!`);
}

// 获取用户uid和ticket
export function getAuthInfo() {
  let auth;
  try {
    const authStr = localStorage.getItem('auth') || '';
    auth = JSON.parse(authStr);
  } catch (e) {
    return;
  }
  return auth;
}

//判断是不是阿语
export const isAr = (str: string) => {
  return /[\u0600-\u06FF\u0750-\u077F]/.test(str);
};

//px转rem
export function px2rem(px: number) {
  return `${px / 75}rem`;
}

export const pearlToCoin = (beans: number) => {
  return beans;
};

export const formatLeftTime = (time: number) => {
  const hour = ~~(time / 3600);
  const minute = ~~((time % 3600) / 60);
  const second = ~~(time % 60);

  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;
};

export const scrollToBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: 'smooth',
  });
};

export const numeric = (num: string) => {
  // 移除非数字字符
  let value = num.replace(/[^\d]/g, '');
  if (value === '') return '';

  // 手动添加逗号（每3位）
  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return value;
};
